import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { SEQUENCES_LIST_KEY } from '@teetsh/app/src/queries/sequences/useSequencesFolders';
import { SEQUENCE_KEY } from '@teetsh/app/src/queries/sequences/useSequence';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export default function useDeleteFicheDePrep() {
  const queryClient = useQueryClient();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['sequence']);
  const { mutateAsync } = useMutation({
    mutationFn: ({
      sequenceId,
      fdpId,
    }: {
      sequenceId: string;
      fdpId: string;
    }) =>
      request(`/sequences/${sequenceId}/fiches-de-prep/${fdpId}`, {
        method: 'DELETE',
      }),

    onSuccess: (_, { sequenceId }) => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_LIST_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [SEQUENCE_KEY, sequenceId],
      });
    },
    onError: () => {
      notifyError({
        title: t('sequence:messages.seance.deleteError'),
      });
    },
  });
  return mutateAsync;
}
